module.exports = __webpack_public_path__ + "static/media/ppdated-map.6e8d5185.png";